const Menu =  [
    { header: 'Admin Quran' },
    {
        path    : '/dashboard',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'dashboard', 
        meta    : {breadcrumb:false}
    }, 
    {
        path    : '/',
        title   : 'Input Nilai Quran',    
        name    : 'tes/quran',  
        icon    : 'local_library', 
    },             
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
